import { defineMessages } from 'react-intl';

export default defineMessages({
  menuAlt: {
    id: 'zo.app.containers.App.menuAlt',
  },
});
